import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WfMdTransitionToTransitionTriggerContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({ providedIn: "root" })
export class WfMdTransitionToTransitionTriggerService extends BaseApiTemplateService<WfMdTransitionToTransitionTriggerContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/process-transition-to-transition-triggers/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/process-transition-to-transition-triggers/backoffice-ep";
    this.httpClient = http;
  }
}
